import Cookies from 'js-cookie';

import { AUTH_COOKIE_NAME } from '@constants';

export const useIsAuth = (): boolean => !!Cookies.get(AUTH_COOKIE_NAME);
